import { axiosNTL } from "../../../services/axios";
import { LanguageListData } from "../types/LanguageData";

const list = () => axiosNTL
  .get(`/language/getLanguages`)
  .then((res: any) => {
    let languageList: LanguageListData[] = res.responseObject;
    return Promise.resolve(languageList);
  });

const languageServices = {
  list,
};

export default languageServices;